import React from "react";
import Text from "@/components/ui/text";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import { cn } from "@/utils/utils";

interface ActionCardProps {
  icon: React.ReactNode;
  text: string;
  onClick: () => void;
  className?: string;
}

export const ActionCard: React.FC<ActionCardProps> = ({
  icon,
  text,
  onClick,
  className = ""
}) => {
  return (
    <div
      className={cn(
        "flex p-4 w-[220px] flex-row justify-start items-center gap-4 border-[0.5px] border-border-border2 rounded-xl bg-surface-elevation2 cursor-pointer h-16",
        className
      )}
      onClick={onClick}
    >
      <LogoIconContainer
        index={-1}
        className="h-8 w-8 rounded-[8px]"
        icon={icon}
        iconSize="sm"
      />
      <Text variant="lgBody">{text}</Text>
    </div>
  );
};
